import jsonlint from 'jsonlint-mod'
import { logError } from 'src/utils/Error'

export function parseJsonSwallowError (str, errorCallback) {
  if (str) {
    try {
      jsonlint.parse(str)
      return JSON.parse(str)
    } catch (e) {
      if (errorCallback) {
        errorCallback(e.message)
      } else {
        logError('Dataset metadata is not well formed\r\n\t' + e + '\r\n\t' + str)
      }
    }
  }
  return null
}
